import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import { unwrapList } from '../lib/unwrap'

export interface AccessGrant {
  id: string
  owner_tenant_id: string
  target_tenant_id: string
  device_id: string
  device_name: string
  permissions: string[]
  expires_at: string | null
  created_at: string
}

export function useGrantedAccess() {
  return useQuery({
    queryKey: ['trust-circle', 'granted'],
    queryFn: () => api.get('/access/granted').then((r) => unwrapList<AccessGrant>(r.data)),
  })
}

export function useReceivedAccess() {
  return useQuery({
    queryKey: ['trust-circle', 'received'],
    queryFn: () => api.get('/access/received').then((r) => unwrapList<AccessGrant>(r.data)),
  })
}

export function useGrantAccess() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: {
      target_tenant_id: string
      device_id: string
      device_name: string
      permissions: string[]
      expires_at?: string
    }) => api.post<AccessGrant>('/access/grant', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['trust-circle'] }),
  })
}

export function useRevokeAccess() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/access/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['trust-circle'] }),
  })
}
